/**
 * Zod validation helper functions for common schema patterns.
 * These predicates are used with .refine() to add custom validation rules.
 */

/**
 * Creates a function to check if the number of selected items is within the available limit.
 * Used for M2M relationships to enforce maximum selection constraints in Zod schemas.
 *
 * @example
 * departmentIds: z
 *   .array(z.string().max(21))
 *   .default([])
 *   .refine(isWithinAvailableSelects(10), { message: '10個以下にしてください' })
 *
 * @param max - The maximum number of selectable items.
 * @returns A function that accepts an array of string IDs and returns a boolean.
 */
export const isWithinAvailableSelects =
  (max: number) =>
  (selects: string[]): boolean => {
    return selects.length <= max
  }
